module.exports = "/images/Iceland.png?07d3fde0769a53a749481c1d0ca18f4f";